import { render, staticRenderFns } from "./SetupApplication.vue?vue&type=template&id=64071c48&scoped=true&"
import script from "./SetupApplication.vue?vue&type=script&lang=js&"
export * from "./SetupApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64071c48",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64071c48')) {
      api.createRecord('64071c48', component.options)
    } else {
      api.reload('64071c48', component.options)
    }
    module.hot.accept("./SetupApplication.vue?vue&type=template&id=64071c48&scoped=true&", function () {
      api.rerender('64071c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/components/Start/SetupApplication.vue"
export default component.exports